import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';

export const Wrapper = styled.div`
    width: 100%;
    display: block;
    overflow: hidden;
    padding-top: 20px;
`;

export const RouterPageTitle = styled.h1`
    font-size: 44px;
    line-height: 56px;
    margin-bottom: 40px;
    width: 100%;
    margin-top: 20px;
    @media (max-width: 1500px) {
        font-size: 32px;
        line-height: 40px;
        margin-bottom: 30px;
    }
    @media (max-width: 1100px) {
        font-size: 24px;
        line-height: 32px;        
        margin-bottom: 20px;
    }
    @media (max-width: 800px) {
        font-size: 20px;
        line-height: 28px;
    }
`;

export const MainContainer = styled(GridContainer)`
    display: flex;
    flex-direction: column;
    font-family: 'robotoLight', Arial, Helvetica, sans-serif;
    font-size: 16px;
    line-height: 1.5em;
    justify-content: flex-start;
    align-items: baseline;
`;

export const RouterListContainer = styled.div`
    width: 100%;
    display: block;
    @media (max-width: 1100px) {
        font-size: 32px;
        line-height: 40px;
    }
    @media (max-width: 900px) {
        font-size: 24px;
        line-height: 32px;
    }
    @media (max-width: 500px) {
        font-size: 20px;
        line-height: 28px;
    }
`;

export const ButtonNavContainer = styled.div`
    background: ${COLORS.lightGrey};
    border-radius: 8px;
    display: flex;
    width: 100%;
    align-items: center;
    box-sizing: border-box;
    padding: 8px 9px;
    margin-bottom: 50px;
    @media (max-width: 1500px) {
        border-radius: 4px;
        margin-bottom: 35px;
    }
    @media (max-width: 1100px) {
        border-radius: 2px;        
        margin-bottom: 30px;
    }
    @media (max-width: 800px) {
        margin-bottom: 25px;
    }
`;

export const ButtonNav = styled.a`
    background: ${props => props.active ? COLORS.green : COLORS.white};
    color: ${props => props.active ? COLORS.white : COLORS.darkGrey};
    font-size: 20px;
    line-height: 28px;
    font-family: 'robotoRegular', Arial, Helvetica, sans-serif;
    border-radius: 8px;
    height: 64px;
    width: 33.3%;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 300px;
    margin-right: 10px;
    box-sizing: border-box;
    :last-child{
      margin-right: 0;
    }
    @media (max-width: 1500px) {
        font-size: 16px;
        line-height: 20px;
        height: 48px;
        min-width: 250px;
        border-radius: 4px;
    }
    @media (max-width: 1100px) {
        min-width: 200px;
        font-size: 14px;
        line-height: 18px;
        height: 40px;
        border-radius: 2px;
    }
    @media (max-width: 500px) { 
        font-size: 12px;
        line-height: 18px;
    }
`;

export const RouterListTitle = styled.h2`
    font-size: 32px;
    line-height: 40px;
    margin-top: 0.67em;
    margin-bottom: 38px;
    width: 100%;
    @media (max-width: 1500px) {
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 20px;
    }
    @media (max-width: 1100px) {
        font-size: 20px;
        line-height: 28px;      
        margin-bottom: 15px;
    }
    @media (max-width: 800px) {
        font-size: 16px;
        line-height: 24px;
    }
`;

export const NavContainer = styled.div`
    width: 100%;
    display: block;
    padding-top: 20px;
`;

export const TestDriveContainer = styled(MainContainer)`
    align-items: center;
    margin-top: 62px;
`;
export const TestDriveContainerWhite = styled.div`
    width: 100%;
    background: ${COLORS.white};
`;

export const SmartContainer = styled(MainContainer)`
    align-items: center;
    margin-top: 62px;
`;
export const QuizSection = styled.div`
    display: block;
    width: 100%;
    padding: 30px 0;
    @media screen and (max-width: 859px) {
        margin-top: 60px;
    }
`;
